// notificationUI.js - UI state for notification interactions
export default {
  namespaced: true,

  state: {
    lastFetchTime: 0,
    loadingFromViewAllClick: false,
    currentNetworkSlug: null
  },

  getters: {
    getLastFetchTime: state => state.lastFetchTime,
    isLoadingFromViewAllClick: state => state.loadingFromViewAllClick,
    getCurrentNetworkSlug: state => state.currentNetworkSlug
  },

  mutations: {
    setLastFetchTime(state, time) {
      state.lastFetchTime = time;
    },
    setLoadingFromViewAllClick(state, value) {
      state.loadingFromViewAllClick = value;
    },
    setCurrentNetworkSlug(state, slug) {
      state.currentNetworkSlug = slug;
    }
  },

  actions: {
    updateLastFetchTime({ commit }, time) {
      commit('setLastFetchTime', time);
    },
    setViewAllClickLoading({ commit }, { loading, networkSlug = null }) {
      commit('setLoadingFromViewAllClick', loading);
      if (networkSlug) {
        commit('setCurrentNetworkSlug', networkSlug);
      }
    },
    resetViewAllClickState({ commit }) {
      commit('setLoadingFromViewAllClick', false);
      commit('setCurrentNetworkSlug', null);
    }
  }
};
